import React from 'react'
import AppView from './AppView'
import myData from './AppConfig.json';
import { UniversalProvider } from './services/UniversalProvider';

const IulaanApp = () => {
  return (
    <UniversalProvider>
     <AppView data={myData} />
    </UniversalProvider>

  )
}

export default IulaanApp
